module.exports = __webpack_public_path__ + "static/media/press_catraca-livre.c2edab39.jpg";